import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const CATEGORY_SEARCH_PAGE_SIZE = 10;

/**
 * Provide the language to be used in Category Service (i.e. 'en')
 */
export const LANGUAGE_TOKEN = new InjectionToken<Observable<string>>('Language Token to be used in Category Service');
